import { AvatarNew } from '@platform/components';

export const PartnerCard = ({ logoUrl, name }: { logoUrl: string; name: string }) => {
  return (
    <div className='bg-gray-50 p-8 flex flex-col gap-2 items-center'>
      <div className='w-16 h-16'>
        <AvatarNew url={logoUrl} alt={`${name} logo`} fallbackIcon='building-06' withPadding />
      </div>
      <div className='text-lg font-semibold'>{name}</div>
    </div>
  );
};
